import Accordion from "./modules/Accordion";
import FormFields from "./modules/FormFields";
import Menu from "./modules/Menu";
import Animate from "./modules/Animate";
import SwiperJs from "./modules/SwipersJs";
import SwiperGallery from "./modules/SwiperGallery";
import Modal from "./modules/Modal";
import PageHero from "./modules/PageHero";
import LoadMore from "./modules/LoadMore";
import CustomSelect from "./modules/CustomSelect";
import CatalogFilterBar from "./modules/CatalogFilterBar";
import Footer from "./modules/Footer";
import CatalogCategories from "./modules/CatalogCategories";
import ProductPopup from "./modules/ProductPopup";
import Header from "./modules/Header";
import ResponsiveHeader from "./modules/ResponsiveHeader";
import PostsLoadMore from "./modules/PostsLoadMore";
import PostsFilterBar from "./modules/PostsFilterBar";
import SinglePage from "./pages/SinglePage";
import CookieSettings from "./modules/CookieSettings";
new Menu();
new Header();
new ResponsiveHeader();
new FormFields();
new Accordion();
new SwiperJs();
new SwiperGallery();
new Modal();
new PageHero();
new LoadMore();
new SinglePage();
new Footer();
console.log('Init app.js');
// declare global window localize_script
window.localize_script = localize_script;
console.log(window.localize_script.admin_ajax);
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
// Init gsap animations
new Animate(); // How to use - look in file
// Custom select dropdown
const customSelects = document.querySelectorAll('[data-js-select]');
customSelects.forEach((select) => new CustomSelect(select));
// Catalog
new CatalogFilterBar();
new CatalogCategories();
new ProductPopup();
// Posts
new PostsFilterBar();
new PostsLoadMore();
// Cookie settings
new CookieSettings();
